import React, { useState, useEffect, forwardRef } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  InputBase,
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Checkbox,
  Tooltip,
  MenuItem,
  DialogActions,
  Button,
  Autocomplete,
  Chip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { MdOutlineDelete } from "react-icons/md";
import { useMediaQuery } from "@mui/material";
import {
  get_all_data,
  delete_card_data,
  get_all_templates,
  send_email,
  render_template,
  generate_ai_email,
  preview_email,
} from "../Api service/APIvariables";
import CustomPagination from "./CustomPagination";
import SendIcon from "@mui/icons-material/Send";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { BiSolidEdit } from "react-icons/bi";
import EditDialogModal from "./EditDiaglogModal";
import { Subject } from "@mui/icons-material";
import SnackBar from "./SnackBar";
import { validateResponseStatus } from "../hooks/Logout";

function CardData({ extractedData, userId }) {
  const [data, setData] = useState([]);
  const [dataOne, setDataOne] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [loading, setLoading] = useState(true);
  const [noDataFound, setNoDataFound] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [deleteTemplateId, setDeleteTemplateId] = useState(false);
  //const [selectedRow, setSelectedRow] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedEditRow, setSelectedEditRow] = useState(0);
  const [statusMessage, setStatusMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [sendEmailDialogOpen, setSendEmailDialogOpen] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [emailSubject, setEmailSubject] = useState("");
  const [emailContent, setEmailContent] = useState("");
  const [emailTo, setEmailTo] = useState([]);
  const [activeCardId, setActiveCardId] = useState(null);
  const [isPreviewMode, setIsPreviewMode] = useState(false);
  const [originalSubject, setOriginalSubject] = useState("");
  const [originalContent, setOriginalContent] = useState("");
  const [attachments, setAttachments] = useState([]);
  const [templates, setTemplates] = useState([]);
  // const [selectDropDown, setSelectDropDown] = useState("false");
  const templateOptions = [
    {
      id: 1,
      name: "Welcome Template",
      content: "Hello, Welcome to our service!",
    },
    {
      id: 2,
      name: "Reminder Template",
      content: "This is a friendly reminder for your upcoming appointment.",
    },
    {
      id: 3,
      name: "Thank You Template",
      content: "Thank you for your continued support!",
    },
  ];

  // const handleTemplateChange = (templateContent) => {
  //   setEmailContent(templateContent);
  // };

  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState(false);
  const [color, setColor] = useState("");
  const [message, setMessage] = useState("");

  const fetchData = async () => {
    try {
      const user_id = localStorage.getItem("user_id");
      const formData = new FormData();
      formData.append("user_id", user_id);

      const token = localStorage.getItem("auth_token");
      // const token =
      //   "eyJpc3MiOiJxdWlja2NhcmQiLCJzdWIiOjEsImlhdCI6MTczODY0MzY5MCwiZXhwIjoxNzM4NzMwMDkwfQ==.48e9f1e24a05cbd4875f725bf1ca56ae0b88f6b6a643796f76f87eeba7c84a2d";
      console.log(token);

      const response = await fetch(get_all_data, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const result = await response.json();

      validateResponseStatus(result);
      console.log(result);

      if (result.data && result.data.length > 0) {
        // Reverse the array to show recently added first
        const dataWithIds = result.data.reverse().map((row, index) => ({
          ...row,
          generatedId: index + 1, // Start from 1 for the most recent
        }));

        setData(dataWithIds);
        setDataOne(dataWithIds);
      } else {
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const handleDelete = async (id) => {
    const userId = localStorage.getItem("user_id");
    const token = localStorage.getItem("auth_token");
    if (!userId || !token) {
      setStatusMessage("User ID or Token is missing!");
      setOpen(true);
      setColor(false);
      setStatus(false);
      return;
    }

    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("user_id", userId);
    formData.append("record_id", id); // Append the template_id to be deleted

    try {
      const response = await fetch(delete_card_data, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`, // Pass the token in the Authorization header
        },
        body: formData, // Send the form data in the request body
      });

      const data = await response.json();

      if (response.ok) {
        setMessage("Template deleted successfully!");
        setOpen(true);
        setColor(true);
        setStatus(true);
        fetchData();

        // setData((prevTemplates) =>
        //   prevTemplates.filter((template) => template.id !== id)
        // );
        fetchData();
      } else {
        setStatusMessage(`Error: ${data?.message || "Unknown error"}`);
        setOpen(true);
        setColor(false);
        setStatus(false);
      }
    } catch (error) {
      setStatusMessage(`Error during deletion: ${error.message}`);
      setOpen(true);
      setColor(false);
      setStatus(false);
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    const searchQuery = search.trim().toLowerCase();

    if (searchQuery === "") {
      setDataOne(data);
    } else {
      const filteredData = dataOne.filter((row) => {
        if (!isNaN(searchQuery)) {
          return row.id === parseInt(searchQuery, 10);
        } else {
          return [
            "name",
            "email",
            "mobile",
            "address",
            "position",
            "company_name",
            "website",
          ].some((key) => row[key]?.toLowerCase().includes(searchQuery));
        }
      });

      setDataOne(filteredData);
      setNoDataFound(filteredData.length === 0);
    }
  }, [search, data]);

  const fetchTemplates = async () => {
    try {
      const user_id = localStorage.getItem("user_id");
      const formData = new FormData();
      formData.append("user_id", user_id);
      // formData.append("template_id", templateId);

      const token = localStorage.getItem("auth_token");
      // console.log(token);

      const response = await fetch(get_all_templates, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to fetch templates");
      }

      const result = await response.json();

      if (result.data) {
        let flatTemplates = [];
        
        if (result.data.user_templates && result.data.user_templates.length > 0) {
            flatTemplates = [...flatTemplates, ...result.data.user_templates.map(t => ({...t, template_name: `[Custom] ${t.template_name}`}))];
        }
        if (result.data.free && result.data.free.length > 0) {
            flatTemplates = [...flatTemplates, ...result.data.free.map(t => ({...t, template_name: `[Free] ${t.template_name}`}))];
        }
        if (result.data.plus && result.data.plus.length > 0) {
            flatTemplates = [...flatTemplates, ...result.data.plus.map(t => ({...t, template_name: `[Plus] ${t.template_name}`}))];
        }
        if (result.data.pro && result.data.pro.length > 0) {
            flatTemplates = [...flatTemplates, ...result.data.pro.map(t => ({...t, template_name: `[Pro] ${t.template_name}`}))];
        }
        if (result.data.unlimited && result.data.unlimited.length > 0) {
            flatTemplates = [...flatTemplates, ...result.data.unlimited.map(t => ({...t, template_name: `[Unlimited] ${t.template_name}`}))];
        }

        if (flatTemplates.length > 0) {
          setTemplates(flatTemplates);
        } else {
          setTemplates([]);
        }
      } else {
        setTemplates([]);
      }
    } catch (error) {
      console.error("Error fetching templates:", error);
      setLoading(false); // You may want to set loading to false here too
    }
  };
  // console.log(templatesOne);
  // useEffect(() => {
  //   fetchTemplates();
  // }, []);

  // Handle pagination
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isMobile = useMediaQuery("(max-width: 768px)");

  const formatDate = (dateString) => {
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    };
    return new Date(dateString).toLocaleString("en-US", options);
  };

  const handleRowClick = (row) => {
    setSelectedRowData(row);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedRowData(null);
  };

  const handleSendEmailDialogOpen = (row) => {
    if (selectedRows.length > 0) {
      handleBulkSendEmailDialogOpen(selectedRows);
      return;
    }

    fetchTemplates();
    setEmailTo(row.email ? [row.email] : []);
    setActiveCardId(row.id);
    setSelectedTemplate("");
    setEmailSubject("");
    setEmailContent("");
    setIsPreviewMode(false);
    setAttachments([]);
    setSendEmailDialogOpen(true);
  };

  const handleBulkSendEmailDialogOpen = (selectedIds) => {
    fetchTemplates();
    const emails = dataOne
      .filter((row) => selectedIds.includes(row.id))
      .map((row) => row.email)
      .filter((email) => email); // remove empty emails
    setEmailTo(emails);
    setActiveCardId(selectedIds.length > 0 ? selectedIds[0] : null);
    setSelectedTemplate("");
    setEmailSubject("");
    setEmailContent("");
    setIsPreviewMode(false);
    setAttachments([]);
    setSendEmailDialogOpen(true);
  };

  const handleSendEmailDialogClose = () => {
    setSendEmailDialogOpen(false);
    setSelectedTemplate("");
    setEmailSubject("");
    setEmailContent("");
  };

  const handleTemplateChange = async (e) => {
    const selectedId = e.target.value;
    setSelectedTemplate(selectedId);
    setIsPreviewMode(false);

    if (selectedId === "none") {
      setEmailSubject("");
      setEmailContent("");
      return;
    }

    // Call render_template API
    try {
      const user_id = localStorage.getItem("user_id");
      const token = localStorage.getItem("auth_token");
      const formData = new FormData();
      formData.append("user_id", user_id);
      formData.append("template_id", selectedId);
      if (activeCardId) {
        formData.append("card_id", activeCardId);
      }

      const response = await fetch(render_template, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      const result = await response.json();
      if (!result.error && result.subject !== undefined) {
        setEmailSubject(result.subject ?? "");
        setEmailContent(result.message ?? "");
      } else {
        // Fallback to static template
        const selectedTemplateObj = templates.find((t) => t.id === selectedId);
        if (selectedTemplateObj) {
          setEmailSubject(selectedTemplateObj.subject ?? "");
          setEmailContent(selectedTemplateObj.message ?? "");
        }
      }
    } catch (error) {
      console.error("Error rendering template:", error);
    }
  };

  const handleSendEmail = async () => {
    try {
      const user_id = localStorage.getItem("user_id");
      const token = localStorage.getItem("auth_token");

      if (!user_id || !token) {
        setMessage("Authentication error");
        setOpen(true);
        setColor(false);
        setStatus(false);
        return;
      }

      const formData = new FormData();
      formData.append("user_id", user_id);
      formData.append("to_email", emailTo.join(","));
      formData.append("subject", emailSubject ?? ""); 
      formData.append("body", emailContent);
      formData.append("role", "admin");
      
      attachments.forEach((file, index) => {
        formData.append(`attachments[]`, file);
      });

      setIsSubmitting(true);
      const response = await fetch(send_email, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const result = await response.json();

      if (result.error === false) {
        setMessage("Email sent successfully!");
        setOpen(true);
        setColor(true);
        setStatus(true);
      } else {
        setMessage(result.message || "Failed to send email");
        setOpen(true);
        setColor(false);
        setStatus(false);
      }
    } catch (error) {
      console.error("Error sending email:", error);
      setMessage("Error sending email");
      setOpen(true);
      setColor(false);
      setStatus(false);
    } finally {
      setIsSubmitting(false);
      setSendEmailDialogOpen(false);
      setSelectedTemplate("");
      setEmailContent("");
      setAttachments([]);
    }
  };

  const handleGenerateAI = async () => {
    const user_id = localStorage.getItem("user_id");
    const token = localStorage.getItem("auth_token");
    if (!user_id || !token) return;

    // Build context from selected companies
    const companyNames = emailTo.map((email) => {
      const row = dataOne.find((r) => r.email === email);
      return row ? row.company_name : "";
    }).filter(Boolean);
    const uniqueCompanies = [...new Set(companyNames)].join(", ");

    const contextStr = window.prompt(
      "Write a brief instruction for the AI (e.g., 'Write an introductory email for our new service'):\n\n" +
      (uniqueCompanies ? `Target Companies: ${uniqueCompanies}` : "")
    );
    
    if (!contextStr) return;

    setIsSubmitting(true);
    try {
      const formData = new FormData();
      formData.append("user_id", user_id);
      formData.append(
        "context",
        contextStr + (uniqueCompanies ? ` (Target Companies: ${uniqueCompanies})` : "")
      );

      const response = await fetch(generate_ai_email, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });
      const result = await response.json();
      if (!result.error && result.data) {
        if (result.data.subject) {
          setEmailSubject(result.data.subject);
        }
        setEmailContent(result.data.body || result.data);
      } else {
        setMessage(result.message || "Failed to generate AI email.");
        setOpen(true);
        setColor(false);
        setStatus(false);
      }
    } catch (e) {
      console.error(e);
      setMessage("Error calling AI.");
      setOpen(true);
      setColor(false);
      setStatus(false);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handlePreviewEmail = async () => {
    if (isPreviewMode) {
      // Revert to original
      setEmailSubject(originalSubject);
      setEmailContent(originalContent);
      setIsPreviewMode(false);
      return;
    }

    try {
      const user_id = localStorage.getItem("user_id");
      const token = localStorage.getItem("auth_token");

      if (!user_id || !token) {
        setMessage("Authentication error");
        setOpen(true);
        setColor(false);
        setStatus(false);
        return;
      }

      setIsSubmitting(true);
      const formData = new FormData();
      formData.append("user_id", user_id);
      formData.append("subject", emailSubject || "");
      formData.append("body", emailContent || "");
      
      // Pass the first selected card ID for preview context if available
      if (activeCardId) {
        formData.append("card_id", activeCardId);
      }

      const response = await fetch(preview_email, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      const result = await response.json();
      if (!result.error) {
        setOriginalSubject(emailSubject);
        setOriginalContent(emailContent);
        setEmailSubject(result.subject || "");
        setEmailContent(result.message || "");
        setIsPreviewMode(true);
        setMessage("Preview generated successfully!");
        setOpen(true);
        setColor(true);
        setStatus(true);
      } else {
        setMessage(result.message || "Failed to generate preview.");
        setOpen(true);
        setColor(false);
        setStatus(false);
      }
    } catch (e) {
      console.error(e);
      setMessage("Error generating preview.");
      setOpen(true);
      setColor(false);
      setStatus(false);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCheckboxChange = (id) => {
    setSelectedRows(
      (prevSelectedRows) =>
        prevSelectedRows.includes(id)
          ? prevSelectedRows.filter((rowId) => rowId !== id) // Remove if already selected
          : [...prevSelectedRows, id] // Add if not selected
    );
    console.log(id);
    console.log(selectedRows); // This will log the previous state (because state updates asynchronously)
  };

  const handleDeleteSelected = () => {
    const filteredData = data.filter(
      (template) => !selectedRowData.includes(template.id)
    );
    setData(filteredData);
    setSelectedRowData([]);
    setMessage("Selected templates deleted!");
    setStatus(true);
    setColor("error");
    setOpen(true);
  };

  // const DeleteConfirmation = ({ handleDelete, rowId }) => {
  const [openDelete, setOpenDelete] = useState(false);

  const handleOpenDelete = (rowId) => {
    setDeleteTemplateId(rowId);
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setDeleteTemplateId(false);
    setOpenDelete(false);
  };

  const handleConfirmDelete = () => {
    handleDelete(deleteTemplateId);
    setOpenDelete(false);
  };

  // console.log(selectedRowData);
  const handleOpenDialog = (record_id) => {
    // setSelectedRows(record_id);
    setSelectedEditRow(record_id);
    setOpenDialog(true);
    // setIsAddTemplate(isAdd);
    // setOpenDialog(true);
    // if (isAdd) {
    //   setEditedTemplate({ name: "", action: "" });
    // } else {
    //   setSelectedTemplate(template);
    //   setEditedTemplate({ name: template.name, action: template.action });
    // }
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleSaveEdit = () => {
    // Update `dataOne` with the edited row data
    setDataOne((prevData) =>
      prevData.map((row) =>
        row.generatedId === selectedRowData.generatedId ? selectedRowData : row
      )
    );
    setOpenEditDialog(false);
  };

  // if (loading) {
  //   return <div>Loading...</div>;
  // }

  // const Transition = forwardRef(function Transition(props, ref) {
  //   return <Slide direction="down" ref={ref} {...props} />;
  // });

  // console.log(openDialog);

  const retrieveTemplateValues = (name) => {
    const selectedTemplateObj = templates.find(
      (template) => template.id === selectedTemplate
    );
    return selectedTemplateObj ? selectedTemplateObj[name] : ""; // Return the value or an empty string if not found
  };

  return (
    <div
      style={{
        display: "block",
        backgroundColor: "#eceff1",
        minHeight: "100vh",
        // padding: "20px",
        position: "relative",
        width: "100%",
        // maxWidth: "98%",
        margin: "0 auto",
        // borderRadius: "30px",
        // paddingRight: "20px",
        paddingLeft: "20px",
        paddingRight: isMobile ? "15px" : "0px",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <SnackBar
        open={open}
        message={message}
        setOpen={setOpen}
        status={status}
        color={color}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          position: "relative",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            width: "100%",
            marginBottom: "20px",
          }}
        >
          {/* Bulk Actions on the left */}
          <Box sx={{ display: "flex", gap: "10px", visibility: selectedRows.length > 0 ? "visible" : "hidden" }}>
            <Tooltip title="Delete Selected">
              <IconButton
                onClick={() => handleOpenDelete(selectedRows)}
                style={{ backgroundColor: "#f44336", color: "#fff" }}
              >
                <MdOutlineDelete />
              </IconButton>
            </Tooltip>
            <Tooltip title="Bulk Send Email">
              <IconButton
                onClick={() => handleBulkSendEmailDialogOpen(selectedRows)}
                style={{ backgroundColor: "#453c72", color: "#fff" }}
              >
                <SendIcon />
              </IconButton>
            </Tooltip>
          </Box>

          {/* Search Box on the right */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: "#eceff1",
              borderRadius: "4px",
              width: isMobile ? "150px" : "200px",
              padding: "2px 10px",
              border: "1px solid #CFD8DC",
              transition: "all 0.3s ease-in-out",
              "&:hover": {
                borderColor: "#1976d2",
                boxShadow: "0 4px 8px rgba(25, 118, 210, 0.2)",
              },
              "&:focus-within": {
                boxShadow: "0 4px 8px rgba(25, 118, 210, 0.2)",
                borderColor: "#1976d2",
              },
            }}
          >
            <InputBase
              sx={{
                ml: 1,
                flex: 1,
                color: "#212121",
                fontSize: "14px",
              }}
              placeholder="Search..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </Box>
        </div>

        <TableContainer
          component={Paper}
          sx={{
            marginTop: "auto",
            width: "100%",
            maxWidth: "1200px",
            overflowX: "auto",
            margin: "0 auto",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          }}
        >
          <Table stickyHeader sx={{ maxWidth: "1200px", margin: "0 auto" }}>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    fontSize: isMobile ? "12px" : "14px",
                    background: "#453c72",
                    color: "white",
                  }}
                >
                  <Checkbox
                    onChange={(e) =>
                      setSelectedRows(
                        e.target.checked ? data.map((row) => row.id) : []
                      )
                    }
                    sx={{ color: "white" }}
                  />
                </TableCell>
                {[
                  "No.",
                  "Name",
                  "Email",
                  // "Mobile",
                  // "Address",
                  "Company Name",
                  "Website",
                  // "Position",
                  // "User ID",
                  "Date & Time",
                  "Send Email",
                  "Action",
                ].map((header) => (
                  <TableCell
                    key={header}
                    style={{
                      backgroundColor: "#453c72",
                      color: "white",
                      fontWeight: "bold",
                      fontSize: { xs: 12, sm: 13, md: 15 },
                      textAlign: "left",
                    }}
                  >
                    {header}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.length === 0 && noDataFound ? (
                <TableRow>
                  <TableCell colSpan={10} align="center">
                    No data available
                  </TableCell>
                </TableRow>
              ) : (
                dataOne
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => (
                    <TableRow
                      key={row.generatedId}
                      // onClick={() => handleRowClick(row)}
                      style={{
                        cursor: "pointer",
                        backgroundColor:
                          index % 2 === 0 ? "#ffffff" : "#f3f3f3",
                      }}
                    >
                      <TableCell sx={{ fontSize: isMobile ? "12px" : "14px" }}>
                        <Checkbox
                          checked={selectedRows.includes(row.id)}
                          onChange={() => handleCheckboxChange(row.id)}
                        />
                      </TableCell>
                      <TableCell
                        style={{
                          padding: "4px 8px",
                          fontSize: { xs: 12, sm: 13, md: 15 },
                        }}
                        onClick={() => handleRowClick(row)}
                      >
                        {row.generatedId || "N/A"}
                      </TableCell>
                      <TableCell
                        style={{
                          padding: "4px 8px",
                          fontSize: { xs: 12, sm: 13, md: 15 },
                        }}
                        onClick={() => handleRowClick(row)}
                      >
                        {row.name || "N/A"}
                      </TableCell>
                      <TableCell
                        style={{
                          padding: "4px 8px",
                          fontSize: { xs: 12, sm: 13, md: 15 },
                        }}
                        onClick={() => handleRowClick(row)}
                      >
                        {row.email ? (
                          <a
                            href={`mailto:${row.email}`}
                            style={{ textDecoration: "none", color: "black" }}
                          >
                            {row.email}
                          </a>
                        ) : (
                          "N/A"
                        )}
                      </TableCell>
                      {/* <TableCell
                        style={{
                          padding: "4px 8px",
                          fontSize: { xs: 12, sm: 13, md: 15 },
                        }}
                        onClick={() => handleRowClick(row)}
                      >
                        {row.mobile ? (
                          <a
                            href={`tel:${row.mobile}`}
                            style={{ color: "#007bff" }}
                          >
                            {row.mobile}
                          </a>
                        ) : (
                          "N/A"
                        )}
                      </TableCell> */}
                      {/* <TableCell
                        style={{ padding: "4px 8px", fontSize: "11px" }}
                        onClick={() => handleRowClick(row)}
                      >
                        {row.address || "N/A"}
                      </TableCell> */}

                      <TableCell
                        style={{
                          padding: "4px 8px",
                          fontSize: { xs: 12, sm: 13, md: 15 },
                        }}
                        onClick={() => handleRowClick(row)}
                      >
                        {row.company_name || "N/A"}
                      </TableCell>
                      <TableCell
                        style={{
                          padding: "4px 8px",
                          fontSize: { xs: 12, sm: 13, md: 15 },
                        }}
                        onClick={() => handleRowClick(row)}
                      >
                        {row.website ? (
                          <a
                            href={row.website}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: "none", color: "black" }}
                          >
                            {row.website}
                          </a>
                        ) : (
                          "N/A"
                        )}
                      </TableCell>

                      {/* <TableCell
                        style={{ padding: "4px 8px", fontSize: "12px" }}
                      >
                        {row.position || "N/A"}
                      </TableCell> */}
                      {/* <TableCell
                        style={{ padding: "4px 8px", fontSize: "12px" }}
                      >
                        {row.user_id || "N/A"}
                      </TableCell> */}
                      <TableCell
                        style={{ padding: "4px 8px", fontSize: "12px" }}
                        onClick={() => handleRowClick(row)}
                      >
                        {row.created_at ? formatDate(row.created_at) : "N/A"}
                      </TableCell>
                      <TableCell>
                        <button
                          onClick={() => handleSendEmailDialogOpen(row)}
                          style={{
                            backgroundColor: "transparent",
                            color: "#453c72",
                            border: "none",
                            padding: "8px",
                            borderRadius: "5px",
                            alignItems: "center",
                          }}
                        >
                          <SendIcon
                            sx={{ fontSize: "18px", alignItems: "center" }}
                          />
                        </button>
                      </TableCell>

                      <TableCell
                        style={{
                          padding: "4px 8px",
                          fontSize: "12px",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            gap: 1,
                          }}
                        >
                          {/* Edit Button */}
                          <IconButton
                            color="primary"
                            onClick={() => handleOpenDialog(row.id)}
                          >
                            <BiSolidEdit style={{ fontSize: "20px" }} />
                          </IconButton>
                          {/* Delete Icon */}
                          <IconButton
                            color="error"
                            onClick={() => handleOpenDelete(row.id)}
                          >
                            <MdOutlineDelete
                              style={{
                                fontSize: "20px",
                                textAlign: "center",
                              }}
                            />
                          </IconButton>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <div
          style={{
            display: "flex",
            width: isMobile ? "100%" : "40%", // Adjust width if necessary
            justifyContent: "flex-end",
            alignItems: "center", // Aligns items properly
            marginLeft: "auto", // Pushes the div to the right
          }}
        >
          <CustomPagination
            count={dataOne?.length}
            rowsPerPage={rowsPerPage}
            page={page} // Use `page` instead of `currentPage`
            onPageChange={handleChangePage} // Use `handleChangePage` here
            onRowsPerPageChange={handleChangeRowsPerPage} // Use `handleChangeRowsPerPage` here
          />
        </div>
      </Box>

      {/* Delete Confirmation modal */}
      <Dialog open={openDelete} onClose={handleCloseDelete}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContent>
            Are you sure? Do you want to delete this file?
          </DialogContent>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDelete} color="primary">
            No
          </Button>
          <Button onClick={handleConfirmDelete} color="error">
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      {/* Send Email Dialog */}
      <Dialog
        className="dialog-modal"
        open={sendEmailDialogOpen}
        onClose={handleSendEmailDialogClose}
        sx={{
          width: "100vw",
          // height: "100%",
          justifyContent: "center",
          alignItems: "center",
          "& .MuiDialogPaper-root": {
            borderRadius: "20px", // Apply borderRadius to the Paper root element
          },
          "& .MuiDialogTitle-root": {
            borderTopLeftRadius: "20px", // Apply to the top-left corner of the title
            borderTopRightRadius: "20px", // Apply to the top-right corner of the title
          },
          "& .MuiDialogContent-root": {
            borderBottomLeftRadius: "20px", // Apply to bottom-left corner of content
            borderBottomRightRadius: "20px", // Apply to bottom-right corner of content
          },
        }}
      >
        <DialogTitle>
          Send Email
          <IconButton
            onClick={handleSendEmailDialogClose}
            sx={{ position: "absolute", top: "10px", right: "10px" }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Autocomplete
            multiple
            freeSolo
            options={[...new Set(dataOne.map((row) => row.email).filter(Boolean))]}
            value={emailTo}
            onChange={(event, newValue) => {
              setEmailTo(newValue);
            }}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip variant="outlined" label={option} {...getTagProps({ index })} />
              ))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="To"
                placeholder="Type an email and press Enter"
                sx={{ marginTop: 2, marginBottom: 2 }}
              />
            )}
          />
          <TextField
            select
            label="Select Template"
            fullWidth
            value={selectedTemplate || ""}
            onChange={(e) => handleTemplateChange(e)}
            sx={{ marginBottom: 2 }}
          >
            <MenuItem value="none">
              <em>None (Custom Email)</em>
            </MenuItem>
            {templates &&
              [...templates].reverse().map((template) => (
                <MenuItem key={template.id} value={template.id}>
                  {template.template_name}
                </MenuItem>
              ))}
          </TextField>

          <TextField
            label="Subject"
            fullWidth
            multiline
            value={emailSubject}
            onChange={(e) => setEmailSubject(e.target.value)}
            sx={{ marginBottom: 2 }}
          />

          {/* Email Content Input */}
          <TextField
            label="Message"
            fullWidth
            multiline
            rows={6}
            value={emailContent}
            onChange={(e) => setEmailContent(e.target.value)}
            sx={{ marginBottom: 2 }}
          />

          {/* Attachment Section */}
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1, marginBottom: 2 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <input
                type="file"
                multiple
                id="email-attachments"
                style={{ display: "none" }}
                onChange={(e) => {
                  if (e.target.files) {
                    setAttachments([...attachments, ...Array.from(e.target.files)]);
                  }
                }}
              />
              <label htmlFor="email-attachments">
                <Button
                  variant="outlined"
                  component="span"
                  startIcon={<AttachFileIcon />}
                  sx={{ textTransform: "none", borderRadius: "7px" }}
                >
                  Attach Files
                </Button>
              </label>
            </Box>
            {attachments.length > 0 && (
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                {attachments.map((file, idx) => (
                  <Chip
                    key={idx}
                    label={file.name}
                    onDelete={() => {
                      const newAtt = [...attachments];
                      newAtt.splice(idx, 1);
                      setAttachments(newAtt);
                    }}
                  />
                ))}
              </Box>
            )}
          </Box>

          {/* Send Email Button & AI Generate Button */}
          <Box sx={{ 
            display: "flex", 
            flexDirection: { xs: "column", sm: "row" }, 
            justifyContent: "space-between", 
            alignItems: { xs: "stretch", sm: "center" }, 
            gap: 2, 
            marginTop: 2 
          }}>
            <Button
              variant="outlined"
              onClick={handleGenerateAI}
              disabled={isSubmitting}
              startIcon={<AutoAwesomeIcon />}
              sx={{
                fontWeight: 600,
                color: "#1976d2",
                borderColor: "#1976d2",
                "&:hover": { backgroundColor: "#e3f2fd" },
                textTransform: "none",
                borderRadius: "7px",
              }}
            >
              Generate AI Email
            </Button>

            {emailTo.length <= 1 && (
              <Button
                variant="outlined"
                onClick={handlePreviewEmail}
                disabled={isSubmitting || (!emailSubject && !emailContent)}
                startIcon={<VisibilityIcon />}
                sx={{
                  fontWeight: 600,
                  color: isPreviewMode ? "#e65100" : "#00897b",
                  borderColor: isPreviewMode ? "#e65100" : "#00897b",
                  "&:hover": { backgroundColor: isPreviewMode ? "#fff3e0" : "#e0f2f1" },
                  textTransform: "none",
                  borderRadius: "7px",
                }}
              >
                {isPreviewMode ? "Revert to Placeholders" : "Preview"}
              </Button>
            )}
            
            <button
              onClick={handleSendEmail}
              disabled={isSubmitting}
              style={{
                display: "flex",
                fontWeight: 600,
                border: "none",
                backgroundColor: isSubmitting ? "#aaa" : "#453c72",
                color: "white",
                borderRadius: "7px",
                padding: "8px 16px",
                alignItems: "center",
                justifyContent: "center",
                cursor: isSubmitting ? "not-allowed" : "pointer",
                width: "100%",
                maxWidth: "150px",
                marginLeft: "auto"
              }}
            >
              {isSubmitting ? "Sending..." : "Send"}
            </button>
          </Box>
        </DialogContent>
      </Dialog>

      {/* Modal for View data */}
      <Dialog
        variant="gradient"
        open={openModal}
        onClose={handleCloseModal}
        // TransitionComponent={Transition}
        PaperProps={{
          sx: {
            width: "500px",
            maxWidth: "100%",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.6)",
            border: "1px solid #CFD8DC",
            borderRadius: "20px",
          },
        }}
      >
        <DialogTitle sx={{ textAlign: "center", fontWeight: "bold" }}>
          Card Details
          <IconButton
            onClick={handleCloseModal}
            sx={{
              position: "absolute",
              top: "10px",
              right: "10px",
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{ padding: "20px", display: "flex", flexDirection: "column" }}
        >
          {selectedRowData ? (
            <div>
              {[
                // { title: "ID", value: selectedRowData.generatedId },
                { title: "Name", value: selectedRowData.name },
                {
                  title: "Email",
                  value: selectedRowData.email ? (
                    <a
                      href={`mailto:${selectedRowData.email}`}
                      style={{ textDecoration: "none", color: "black" }}
                    >
                      {selectedRowData.email}
                    </a>
                  ) : (
                    "N/A"
                  ),
                },
                {
                  title: "Mobile",
                  value: selectedRowData.mobile ? (
                    <a
                      href={`tel:${selectedRowData.mobile}`}
                      style={{ textDecoration: "none", color: "black" }}
                    >
                      {selectedRowData.mobile}
                    </a>
                  ) : (
                    "N/A"
                  ),
                },
                { title: "Address", value: selectedRowData.address },
                { title: "Company Name", value: selectedRowData.company_name },
                {
                  title: "Website",
                  value: selectedRowData.website ? (
                    <a
                      href={selectedRowData.website}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none", color: "black" }}
                    >
                      {selectedRowData.website}
                    </a>
                  ) : (
                    "N/A"
                  ),
                },
                { title: "Position", value: selectedRowData.position },
                // { title: "User ID", value: selectedRowData.user_id },
                {
                  title: "Date & Time",
                  value: selectedRowData.created_at
                    ? formatDate(selectedRowData.created_at)
                    : "N/A",
                },
              ].map(({ title, value }) => (
                <Box
                  key={title}
                  sx={{
                    color: "#black",
                    display: "flex",
                    // justifyContent: "space-between",
                    gap: 2,
                    marginBottom: "10px",
                    padding: "8px",
                    backgroundColor: "white",
                    // border: "1px solid #CFD8DC",
                    borderRadius: "8px",
                    backgroundColor: "#f5f5f5",
                    borderRadius: "10px",
                    // boxShadow:
                    //   "inset 20px 20px 60px #cfcfd4, inset -20px -20px 60px #ffffff",
                  }}
                >
                  <Box
                    sx={{
                      fontWeight: "bold",
                      fontSize: "16px",
                      minWidth: "150px", // Ensure the title column is evenly spaced
                      textAlign: "left",
                    }}
                  >
                    {title}
                  </Box>
                  <Box
                    sx={{
                      fontWeight: "bold",
                      fontSize: "16px",
                      padding: "0 10px",
                    }}
                  >
                    :
                  </Box>
                  <Box
                    sx={{
                      fontSize: "14px",
                      flexGrow: 1, // This ensures the value takes up the remaining space
                    }}
                  >
                    {value || "N/A"}
                  </Box>
                </Box>
              ))}
            </div>
          ) : null}
        </DialogContent>
      </Dialog>

      <EditDialogModal
        openDialog={openDialog}
        setOpenDialog={setOpenDialog}
        fetchData={fetchData}
        record_id={selectedEditRow}
        setSelectedEditRow={setSelectedEditRow}
        setOpen={setOpen}
        setStatus={setStatus}
        setColor={setColor}
        setMessage={setMessage}
      />
    </div>
  );
}

export default CardData;
